import request from '@/api/config/request'

const prex = "api/pessoa/";

export function getEmpresas(data) {
    return request({
        url: `${prex}empresas`,
        method: 'post',
        data
    })
}

export function getPrestador(data) {
    return request({
        url: `${prex}prestador`,
        method: 'post',
        data
    })
}

export function getTomador(data) {
    return request({
        url: `${prex}tomador`,
        method: 'post',
        data
    })
}

export function getContador(data) {
    return request({
        url: `${prex}contador`,
        method: 'post',
        data
    })
}

export function getSocio(data) {
    return request({
        url: `${prex}socio`,
        method: 'post',
        data
    })
}

export function getAtividadeCnae(data) {
    return request({
        url: `${prex}atividade_cnae`,
        method: 'post',
        data
    })
}

export function getBaseMensal(data) {
    return request({
        url: `${prex}base_mensal`,
        method: 'post',
        data
    })
}

export function getComplementoServico(data) {
    return request({
        url: `${prex}complemento_servico`,
        method: 'post',
        data
    })
}